import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CentralClientePacotesClienteRoutingModule } from './central-cliente-pacotes-cliente-routing.module';
import { CentralClientePacotesClienteComponent } from './central-cliente-pacotes-cliente.component';
import { DividerModule } from 'primeng/divider';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { MessagesModule } from 'primeng/messages';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    CentralClientePacotesClienteComponent
  ],
  imports: [
    CommonModule,
    CentralClientePacotesClienteRoutingModule,
    FormsModule,
    TableModule,
    DividerModule,
    ButtonModule,
    MessagesModule,
    InputTextModule,
    DropdownModule,
    TooltipModule,
    ProgressSpinnerModule
  ]
})
export class CentralClientePacotesClienteModule { }
